import { ENVIRONMENT_URL, DATAVERSE_TABLES } from '../constants/dataverse';

const environmentUrl = ENVIRONMENT_URL;

function extractQualityTourId(record: Record<string, unknown>): string | null {
  const id =
    record.cr3ea_qualitytourid ??
    record.cr3ea_prod_qualitytourid ??
    record.id;
  return typeof id === 'string' && id.length > 0 ? id : null;
}

// Environment URL
// const environmentUrl = "https://org487f0635.crm8.dynamics.com";dev
export async function createOrFetchPlantTour({
  accessToken,
  departmentId,
  employeeName,
  roleName,
  plantId,
  userRoleID,
}: {
  accessToken: string;
  departmentId: string;
  employeeName: string;
  roleName: string;
  plantId: string;
  userRoleID: string;
}): Promise<string | null> {
  if (!accessToken) return null;

  const apiVersion = "9.2";
  const candidateTables = Array.from(new Set([
    DATAVERSE_TABLES.QUALITY_TOUR,
    'cr3ea_prod_qualitytours',
    'cr3ea_qualitytours',
    'cr3ea_rajpura_quality_tours'
  ]));

  const now = new Date();
  const pad = (n: number) => n.toString().padStart(2, "0");
  const TourStartDateDTour = `${pad(now.getMonth() + 1)}-${pad(now.getDate())}-${now.getFullYear()} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
  const TitleDTour = `${roleName}_${pad(now.getMonth() + 1)}-${pad(now.getDate())}-${now.getFullYear()}`;

  const header = {
    Accept: "application/json",
    "Content-Type": "application/json; charset=utf-8",
    "OData-MaxVersion": "4.0",
    "OData-Version": "4.0",
    Prefer: "return=representation",
    Authorization: `Bearer ${accessToken}`,
  };

  const dataToSave = {
    cr3ea_departmentid: departmentId?.toString(),
    cr3ea_tourstartdate: TourStartDateDTour,
    cr3ea_tourby: employeeName,
    cr3ea_status: "In Progress",
    cr3ea_plantid: plantId?.toString(),
    cr3ea_observedby: employeeName,
    cr3ea_roleid: userRoleID?.toString(),
    cr3ea_title: TitleDTour,
  };

  let lastError: Error | null = null;

  for (const tableName of candidateTables) {
    const apiUrl = `${environmentUrl}/api/data/v${apiVersion}/${tableName}`;
    
    // Check if a tour is already in progress
    const checkUrl = `${apiUrl}?$filter=cr3ea_status eq 'In Progress' and cr3ea_departmentid eq '${departmentId}'&$top=1`;
    try {
      const isPlantTourExist = await fetch(checkUrl, {
        method: "GET",
        headers: header,
      });

      if (isPlantTourExist.status === 404) {
        console.warn(`Table ${tableName} not found (404), trying next candidate...`);
        continue;
      }

      if (isPlantTourExist.ok) {
        const plant_tour_res = await isPlantTourExist.json();
        if (plant_tour_res.value && plant_tour_res.value.length > 0) {
          return extractQualityTourId(plant_tour_res.value[0]);
        }

        // Create new tour on working table
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: header,
          body: JSON.stringify(dataToSave),
        });

        if (response.ok) {
          const data = await response.json();
          return extractQualityTourId(data);
        } else {
          const errText = await response.text();
          lastError = new Error(`POST ${tableName} failed: ${response.status} - ${errText}`);
        }
      } else {
        const errText = await isPlantTourExist.text();
        lastError = new Error(`GET ${tableName} failed: ${isPlantTourExist.status} - ${errText}`);
      }
    } catch (err: any) {
      console.error(`Error querying candidate table ${tableName}:`, err);
      lastError = err;
    }
  }

  if (lastError) throw lastError;
  return null;
}
